import React from 'react';
import PropTypes from 'prop-types';
import SMConst from 'lib/SMConst';

class SMEditMenuTableRow extends React.Component {
  
  didClickAddButton(e) {
    this.props.delegate.addNewPlanDidSelect();
  }
  
  didSelect(e){
    if(this.props.delegate && typeof this.props.delegate.tableDidSelectRowAtIndex === 'function'){
      this.props.delegate.tableDidSelectRowAtIndex(this.props.rowIndex);
    }
    e.preventDefault();
  }

  render() {
    let className = "dashboard-sidecol__scrollarea-list form-list form-list__status";
    
    if (this.props.isCurrent) {
      className += ' is-current';
    }

    if (this.props.rowType == SMConst.TableRowType.Section) {
      className += ' form-list__section';

      return (
        <li className={className}>{this.props.title}</li>
      );
    } else if (this.props.rowType == SMConst.TableRowType.SectionWithAddButton) {
      className += ' form-list__section';
      
      return (
        <li className={className}>
          {this.props.title}
          <a href="#" className="button-gray form-list__section-add" onClick={this.didClickAddButton.bind(this)}><i className="fa fa-plus"></i> 追加</a>
        </li>
      );
    } else {
      switch (this.props.accessoryType) {
        case SMConst.AccessoryType.Checked: 
          className += " is-complete"; break;
        case SMConst.AccessoryType.UnMarked: 
          className += " is-unmarked"; break;
      }

      return (
        <li className={className}>
          <a href="#" onClick={this.didSelect.bind(this)} className="form-list__link dashboard-sidecol__scrollarea-list-link">
            {this.props.title}
          </a>  
        </li>
      );
    }
  }
}
SMEditMenuTableRow.propTypes = {
  title: PropTypes.string.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowType: PropTypes.number,
  isCurrent: PropTypes.bool,
  accessoryType: PropTypes.number,
  delegate: PropTypes.object
};
SMEditMenuTableRow.defaultProps = {
  rowIndex: 0,
  isCurrent: false,
  rowType: SMConst.TableRowType.Default,
  accessoryType: SMConst.AccessoryType.None
};
export default SMEditMenuTableRow;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMEditMenuTableRow.jsx